<script>
import { cloneDeep, isEqual } from "lodash"
import DEFAULTCONFIG from "@/components/base/conf"
import types from "@/components/base/conf/types.js"
import { findData, isEmptyOrNull } from "@/utils/common.js"
import formAutoComplete from "@/components/base/form/formAutoComplete"
import formCalendar from "@/components/base/form/formCalendar"
import formDatePicker from "@/components/base/form/formDatePicker"
import formHidden from "@/components/base/form/formHidden"
import formInput from "@/components/base/form/formInput"
import formInputNumber from "@/components/base/form/formInputNumber"
import formMultiple from "@/components/base/form/formMultiple"
import formSearchList from "@/components/base/form/formSearchList"
import formSelect from "@/components/base/form/formSelect"
import formStepper from "@/components/base/form/formStepper"
import formSwitch from "@/components/base/form/formSwitch"
import formTreeSelect from "@/components/base/form/formTreeSelect"
import scopedSlots from "./scopedSlots"
//ref 统一name开头  对应field
const REF_NAME = "field"

// 请求表单项可选数据
const fetchItemPropsOptionsApiList = async function(_vm) {
  let that = _vm
  let { onOptionsLoadBefore, apiList: list } = that
  if (onOptionsLoadBefore) {
    const beforeRes = onOptionsLoadBefore(list)
    if (beforeRes === false) {
      return false
    } else if (beforeRes) {
      list = beforeRes
    }
  }

  let promises = list.map((p) => {
    return p.api(p.param)
  })
  Promise.all(promises).then((res) => {
    let {
      autoSetDefaultValue,
      autoSetFirstValue,
      selectOptions,
      onOptionsLoadAfter,
    } = that
    let json = {}
    let apiFields = []
    list.forEach((item, index) => {
      let { field, fields } = item
      let itemData = res[index]
      if (fields && fields.length) {
        // 统一请求可选数据 赋值到指定字段的处理
        fields.forEach((p) => {
          let field = p.field
          const optionsData = handlefieldOptionsDataField(field, itemData, that)
          json[p.field] = optionsData
          apiFields.push(p.field)
        })
      } else {
        // 字段单独配置api的可选数据的处理
        const optionsData = handlefieldOptionsDataField(field, itemData, that)
        json[field] = optionsData
        apiFields.push(field)
        // json[field] = itemData;
      }
    })
    if (that.onOptionsAllLoad) {
      json = that.onOptionsAllLoad(json)
    }

    that.setFieldsOptions(json)

    that.selectOptions = {
      ...selectOptions,
      ...json,
    }
    let defaultFormData = {}
    if (autoSetDefaultValue || autoSetFirstValue) {
      defaultFormData = that.setFieldsOptionsDefaultValues(apiFields)
    }

    if (onOptionsLoadAfter) {
      onOptionsLoadAfter(json, defaultFormData)
    }
  })
}

//查找下拉返回数据
function handlefieldOptionsDataField(field, json, that) {
  let item = that.itemsOptionsIndexs[field]
  if (item && item.itemRender && item.itemRender.props) {
    const itemProps = item.itemRender.props
    const df =
      itemProps.dataField != undefined
        ? itemProps.dataField
        : DEFAULTCONFIG.getSelectOptions.dataField
    json = findData(json, df)
  }
  return json
}

export default {
  name: "dataForm",
  components: {
    formAutoComplete,
    formCalendar,
    formDatePicker,
    formHidden,
    formInput,
    formInputNumber,
    formMultiple,
    formSearchList,
    formSelect,
    formStepper,
    formSwitch,
    formTreeSelect,
    scopedSlots,
  },
  props: {
    //表单数据
    items: {
      type: Array,
      default: () => [],
    },
    // 是否只读
    readonly: {
      type: Boolean,
      default: false,
    },
    // 可选数据全部请求完后回调
    onOptionsAllLoad: {
      type: Function,
      default: null,
    },
    // 可选数据请求前回调
    onOptionsLoadBefore: {
      type: Function,
      default: null,
    },
    // 可选数据请求后回调
    onOptionsLoadAfter: {
      type: Function,
      default: null,
    },
    // 获取数据时是否清除空值字段值
    filterNullValues: {
      type: Boolean,
      default: DEFAULTCONFIG.form.dataForm.filterNullValues,
    },
    //自动加载请求
    autoLoadOptionsData: {
      type: Boolean,
      default: DEFAULTCONFIG.form.dataForm.autoLoadOptionsData,
    },
    //自动设置默认值 根据key
    autoSetDefaultValue: {
      type: Boolean,
      default: DEFAULTCONFIG.form.dataForm.autoSetDefaultValue,
    },
    //自动设置第一项为默认值
    autoSetFirstValue: {
      type: Boolean,
      default: DEFAULTCONFIG.form.dataForm.autoSetFirstValue,
    },
    // 所有项的标题宽度
    titleWidth: {
      type: [String, Number],
      default: DEFAULTCONFIG.form.dataForm.titleWidth,
    },
    //是否弹出提示
    errorToast: {
      type: Boolean,
      default: DEFAULTCONFIG.form.dataForm.errorToast,
    },
    //错误提示
    errorText: {
      type: [String, Boolean],
      default: DEFAULTCONFIG.form.dataForm.errorText,
    },
  },
  data() {
    return {
      //下拉数据
      selectOptions: {},
      //渲染数据
      itemsOptions: [],
      //老数据
      oldItems: {},
      //有返回数据的item集合索引
      itemsOptionsIndexs: {},
      //下拉请求list
      apiList: [],
      //有返回数据的Form组件名称
      optionsFormTypes: ["formMultiple", "formSelect", "formTreeSelect"],
    }
  },
  watch: {
    items() {
      this.cloneItems()
    },
  },
  created() {
    this.cloneItems()
  },
  methods: {
    setValue(data, isInitial) {
      let formData = this.formData
      for (let i in data) {
        if (formData[i]) {
          formData[i].value = data[i]
          if (isInitial) formData[i].initialValue = data[i]
        }
      }
      this.formData = formData
    },
    /**
     * @description: 初始化
     * @param {*} isAll
     * @param {*} callback
     * @return {*}
     */
    cloneItems(isAll) {
      let { items, optionsFormTypes, oldItems: prevItems, selectOptions } = this
      const getSelectOptions = DEFAULTCONFIG.getSelectOptions

      let itemsOptionsIndexs = {}
      let oldItems = {}
      let unifyApiList = {
        api: getSelectOptions && getSelectOptions.api,
        param: {},
        fields: [],
      }
      let otherApiList = []
      const itemsOptions = cloneDeep(items).map((item, index) => {
        let field = item.field
        let itemRender = item.itemRender || {}
        item.itemRender = itemRender
        itemRender.props = itemRender.props || {}
        let name = types[itemRender.name || "input"]
        itemRender.name = name
        let itemProps = itemRender.props
        let prevItem = prevItems[field]
        oldItems[field] = item
        item.index = index
        itemsOptionsIndexs[field] = item
        if (optionsFormTypes.includes(name)) {
          if (
            !isAll &&
            prevItem &&
            prevItem.itemRender.props.api === itemProps.api &&
            isEqual(prevItem.itemRender.props.param, itemProps.param)
          ) {
            //赋值
            if (selectOptions[field]) {
              itemProps.options = selectOptions[field]
            }
            return item
          }
          if (itemProps.api) {
            otherApiList.push({
              field,
              api: itemProps.api,
              param: itemProps.param,
            })
          } else if (itemProps.param) {
            for (let key in itemProps.param) {
              if (
                unifyApiList.param[key] &&
                unifyApiList.param[key] instanceof Array
              ) {
                unifyApiList.param[key].push(itemProps.param[key])
              } else {
                unifyApiList.param[key] = [itemProps.param[key]]
              }
            }
            unifyApiList.fields.push(item)
          }
        }
        return item
      })
      this.itemsOptions = itemsOptions
      this.itemsOptionsIndexs = itemsOptionsIndexs
      if (unifyApiList.fields.length > 0) {
        otherApiList = otherApiList.concat(unifyApiList)
      }
      this.apiList = otherApiList
      this.oldItems = cloneDeep(oldItems)
      if (otherApiList.length > 0 && (this.autoLoadOptionsData || isAll)) {
        this.loadOptionsData()
      }
    },
    /**
     * @description: 请求
     * @param {*} formData
     * @param {*} callback
     * @param {*} isAll
     * @return {*}
     */
    loadOptionsData(isAll) {
      if (isAll) {
        this.cloneItems(isAll)
      } else if (this.apiList) {
        fetchItemPropsOptionsApiList(this)
      }
    },
    /**
     * @description: 重置
     * @param {*}
     * @return {*}
     */
    restore() {
      let { itemsOptionsIndexs: indexs, itemsOptions } = this
      let formData = {}
      itemsOptions = cloneDeep(itemsOptions)
      for (let i = 0; i < itemsOptions.length; i++) {
        let item = itemsOptions[i]
        let itemRender = item.itemRender
        let field = item.field
        let name = itemRender.name
        if (indexs[field] && indexs[field].initialValue) {
          formData[field] = indexs[field].initialValue
        } else if (
          name == "formMultiple" ||
          (name == "formTreeSelect" && itemRender.props.multiple)
        ) {
          formData[field] = []
        } else if (name == "switch") {
          formData[field] = false
        } else {
          formData[field] = ""
        }
      }
      this.setData(formData)
    },
    /**
     * @description: 清空
     * @param {*}
     * @return {*}
     */
    clear() {
      let itemsOptions = cloneDeep(this.itemsOptions)
      let formData = {}
      for (let i in itemsOptions) {
        let item = itemsOptions[i]
        let itemRender = item.itemRender
        let field = item.field
        let name = itemRender.name
        if (
          name == "formMultiple" ||
          (name == "formTreeSelect" && itemRender.props.multiple)
        ) {
          formData[field] = []
        } else if (name == "switch") {
          formData[field] = false
        } else {
          formData[field] = ""
        }
      }
      this.setData(formData)
    },
    /**
     * @description: 获取select数据
     * @param {*}
     * @return {*}
     */
    getFieldsOptions() {
      return this.selectOptions
    },
    /**
     * @description: 设置select数据
     * @param {*}
     * @return {*}
     */
    setFieldsOptions(data) {
      let {
        itemsOptions,
        itemsOptionsIndexs,
        optionsFormTypes,
        selectOptions,
      } = this
      for (let i in data) {
        let row = itemsOptionsIndexs[i]
        if (row) {
          let index = row.index
          let item = itemsOptions[index]
          if (optionsFormTypes.includes(item.itemRender.name)) {
            let options = data[i]
            selectOptions[i] = options
            item.itemRender.props.options = options
          }
        }
      }
      this.itemsOptions = cloneDeep(itemsOptions)
      this.selectOptions = selectOptions
    },
    /**
     * @description: 设置默认值
     * @param {*} fields
     * @return {*}
     */
    setFieldsOptionsDefaultValues(fields) {
      let that = this
      let { autoSetFirstValue, itemsOptions } = that
      let formData = {}
      let defaultFormData = {}
      itemsOptions.forEach((item) => {
        let itemRender = item.itemRender
        let props = itemRender.props
        if (
          !props.unDefaultSelected &&
          ((fields.length && fields.includes(item.field)) ||
            fields.length === 0)
        ) {
          let field = item.field
          let getSelectOptions = DEFAULTCONFIG.getSelectOptions
          const defaultKey = props.defaultField
            ? props.defaultField
            : getSelectOptions.defaultField
          const valueField = props.valueField
            ? props.valueField
            : getSelectOptions.valueField
          let options = props.options
          let name = itemRender.name
          if (
            ["formMultiple", "formSelect"].includes(name) &&
            options &&
            options.length > 0
          ) {
            let defaultRows
            if (autoSetFirstValue) {
              defaultRows = [options[0]]
            } else {
              defaultRows = options.filter((p) => p[defaultKey])
            }
            if (defaultRows.length > 0) {
              let defaultValue = defaultRows.map((p) => {
                return p[valueField]
              })
              if (name == "formSelect") {
                defaultRows = defaultRows[0]
                defaultValue = defaultValue[0]
              }
              formData[field] = defaultValue
              defaultFormData[field] = defaultRows
            }
          }
        }
      })

      this.setData(formData)

      return defaultFormData
    },
    /**
     * @description: 验证数据必填 并返回数据
     * @param {*}
     * @return {*}
     */
    validateFields() {
      let that = this
      return new Promise((resolve, reject) => {
        let { itemsOptions, filterNullValues, errorToast, errorText } = that
        let formData = {}
        for (let i = 0; i < itemsOptions.length; i++) {
          let item = itemsOptions[i]
          let itemRender = item.itemRender
          let field = item.field
          let dom = that.$refs[REF_NAME + field]
          if (dom) {
            let value = dom.getValue()
            if (item.required) {
              let name = itemRender.name
              if (
                name == "formMultiple" ||
                (name == "formTreeSelect" && itemRender.props.multiple)
              ) {
                if (value.length == 0) {
                  if (errorToast) {
                    this.$toast.fail(errorText + item.title)
                  }
                  reject(item)
                  break
                }
              } else if (!value) {
                if (errorToast) {
                  this.$toast.fail(errorText + item.title)
                }
                reject(item)
                break
              }
            }
            if (filterNullValues && isEmptyOrNull(value)) continue
            formData[field] = value
          }
        }
        resolve(formData)
      })
    },
    /**
     * @description: 获取值
     * @param {*} type 若传true  认为添加的是可重置的值
     * @return {*}
     */
    getData() {
      let { itemsOptions, filterNullValues } = this
      let formData = {}
      for (let i = 0; i < itemsOptions.length; i++) {
        let item = itemsOptions[i]
        let field = item.field
        let dom = this.$refs[REF_NAME + field]
        if (dom) {
          let value = dom.getValue()
          if (filterNullValues && isEmptyOrNull(value)) continue
          formData[field] = value
        }
      }
      return formData
    },
    /**
     * @description: 赋值
     * @param {*} data
     * @param {*} type 若传true  认为添加的是可重置的值
     * @return {*}
     */
    setData(data, type) {
      let { itemsOptionsIndexs } = this
      for (let i in data) {
        let row = itemsOptionsIndexs[i]
        if (row) {
          let dom = this.$refs[REF_NAME + row.field]
          if (dom) {
            let value = data[i]
            dom.setValue(value)
            if (type) {
              itemsOptionsIndexs[i].initialValue = value
            }
          }
        }
      }
      if (type) {
        this.itemsOptionsIndexs = itemsOptionsIndexs
      }
    },
    /**
     * @description: 输入框渲染
     * @param {*} h
     * @return {*}
     */
    fieldRender(h) {
      let { itemsOptions, titleWidth } = this
      return itemsOptions.map((p) => {
        let field = p.field
        let itemRender = p.itemRender
        let itemProps = itemRender.props
        let ref = REF_NAME + field
        //插槽
        if (itemRender.slot) {
          let { $slots, $scopedSlots } = this
          if (typeof itemRender.slot == "string") {
            if ($slots[itemRender.slot]) {
              return $slots[itemRender.slot]
            } else if ($scopedSlots[itemRender.slot]) {
              return h("scopedSlots", {
                ref,
                scopedSlots: {
                  default: $scopedSlots[itemRender.slot],
                },
              })
            }
          } else {
            return itemRender.slot(p)
          }
        }

        itemProps.title = p.title
        itemProps.required = p.required
        let option = {
          key: field,
          ref,
          props: { titleWidth, ...itemProps },
          on: {
            ...itemRender.on,
          },
          scopedSlots: {
            ...itemRender.scopedSlots,
          },
          slots: {
            ...itemRender.scopedSlots,
          },
        }

        return h(itemRender.name, option)
      })
    },
  },
  render(h) {
    return (
      <form>
        <van-cell-group>{this.fieldRender(h)}</van-cell-group>
      </form>
    )
  },
}
</script>
<style lang="less" scoped></style>
